import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Grid} from '@vio/atlas/helpers/Grid'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

const StyledGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export const PaymentInformationSkeleton = () => {
  return (
    <Box
      paddingTop="s400"
      paddingBottom="s400"
      display="flex"
      flexDirection="column"
      gap="s600"
    >
      <Grid alignItems="center">
        <StyledGrid>
          <SkeletonLoader width={120} />
          <SkeletonLoader width={120} marginTop={0} />
        </StyledGrid>
      </Grid>
      <StyledGrid>
        <SkeletonLoader width={160} />
        <SkeletonLoader width={160} marginTop={0} />
      </StyledGrid>
    </Box>
  )
}

export const PriceDetailsSkeleton = () => {
  return <SkeletonLoader width={75} />
}

export const TotalPriceSkeleton = () => {
  return <SkeletonLoader width={90} marginTop={0} />
}

export const TotalPriceTitleSkeleton = () => {
  return <SkeletonLoader width={90} />
}
